<template>
  <mobile-container>
    <MobileHeader slot="header"
                  nav-action="home">
      Burger Boss
    </MobileHeader>
    <div :class="$style.locationList">

      <v-autocomplete
        :class="$style.citiesSearch"
        :items="rests"
        :search-input.sync="searchParam"
        append-icon=""
        hide-no-data
        hide-details
        label="ZIP or City"
        color="#38AA3F"
        item-text="city"
        @input="changeSearch"
      />

      <div v-if="rests.length === 0"
           :class="$style.loadingContainer">
        <LoadingSpinner/>
      </div>
      <VList :class="$style.storesList">
        <VListTile
          v-for="store in filteredRests"
          :key="store.id"
          :class="$style.storesListItem"
          ripple
          @click="goToLocation(store.id)"
        >
          <div :class="$style.storesListItemContent">
            <div :class="$style.storeInfo">
              <h4>{{ store.city }}</h4>
              <p>{{ store.address }} </p>
              <p>{{ formatPhone(store.phone) }}</p>
            </div>

            <div :class="$style.storeButtons">
              <span>{{ formatDistance(store.distance) }}</span>
            </div>
          </div>
        </VListTile>
      </VList>

    </div>
  </mobile-container>
</template>

<script>
import Component from 'vue-class-component';
import { Getter } from 'vuex-class';
import Vue from 'vue';
import utils from '@/lib/helpers';
import MobileContainer from '@/apps/mobile/components/MobileContainer';
import MobileHeader from '@/apps/mobile/components/MobileHeader';
import LoadingSpinner from '@/apps/configurator/components/LoadingSpinner';

/**
 * Page to pick nearest restaurant locations.
 */
@Component({
  components: {
    MobileHeader,
    MobileContainer,
    LoadingSpinner,
  },
})
export default class MobileLocationList extends Vue {
  searchParam = '';
  @Getter rests;
  @Getter restByKey;

  formatPhone = utils.formatPhoneDots;
  formatDistance = utils.formatDistance;
  /**
   * Filter restaurants list by city or by zip
   */
  get filteredRests() {
    if (this.searchParam) {
      const searchCityString = this.searchParam.toLowerCase();

      return this.rests.filter(item =>
        item.city.toLowerCase().includes(searchCityString)
        || item.zip.toLowerCase().includes(searchCityString));
    }

    return this.rests;
  }

  /**
   * Set `searchParam` param from filter restaurants
   */
  changeSearch(city) {
    this.searchParam = city;
  }

  /**
   * Go to location.
   * @param id
   */
  goToLocation(id) {
    this.$router.push({ name: 'location-detail', params: { restId: id } });
  }
}
</script>

<style lang="scss" module>
@import "@/style/variables.scss";
@import "@/style/helpers.scss";

.loadingContainer {
  position: relative;
  height: 100%;
  min-height: 200px;
}

.locationList {
  width: 100%;
  background: $mobile-locations-list-bg;
}

.storesList {
  padding: 0;
}

.storesListItem {
  margin: 0;
  width: 100%;
  box-shadow: 0 1px 2px 0 $mobile-card-shadow-color;
  font-family: $main-font-family;
  color: $black;
  background: $white;

  &+& {
    margin-top: 6px;
  }

  &Content {
    padding: 10px $mobile-content-side-padding 12px;
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: self-start;
  }

  .storeInfo {
    width: 70%;
  }

  h4 {
    font-family: $main-font-family;
    color: $black;
    font-weight: 700;
    font-size: 1rem;
    letter-spacing: -0.21px;
  }
  p {
    font-family: $main-font-family;
    color: $black;
    font-size: 1rem;
    font-weight: 300;
    letter-spacing: -0.21px;
  }
  span {
    color: $black-semi-transparent;
    font-size: 12px;
    font-style: italic;
    text-align: center;
  }
}

.storeButtons {
  margin: 11px 25px 0 30px;
  flex-shrink: 0;
}

.citiesSearch {
  color: $black;
  font-family: $main-font-family;
  font-size: 15px;
  font-weight: 300;
  letter-spacing: -0.21px;
  line-height: 20px;
  padding: $mobile-content-side-padding;
}
</style>



// WEBPACK FOOTER //
// src/apps/mobile/components/MobileLocationList.vue